(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagna-status', {
            parent: 'entity',
            url: '/campagna-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnaStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-status/campagna-statuses.html',
                    controller: 'CampagnaStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnaStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagna-status-detail', {
            parent: 'entity',
            url: '/campagna-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnaStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-status/campagna-status-detail.html',
                    controller: 'CampagnaStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnaStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CampagnaStatus', function($stateParams, CampagnaStatus) {
                    return CampagnaStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagna-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagna-status-detail.edit', {
            parent: 'campagna-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-status/campagna-status-dialog.html',
                    controller: 'CampagnaStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CampagnaStatus', function(CampagnaStatus) {
                            return CampagnaStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-status.new', {
            parent: 'campagna-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-status/campagna-status-dialog.html',
                    controller: 'CampagnaStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagna-status', null, { reload: 'campagna-status' });
                }, function() {
                    $state.go('campagna-status');
                });
            }]
        })
        .state('campagna-status.edit', {
            parent: 'campagna-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-status/campagna-status-dialog.html',
                    controller: 'CampagnaStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CampagnaStatus', function(CampagnaStatus) {
                            return CampagnaStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-status', null, { reload: 'campagna-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-status.delete', {
            parent: 'campagna-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-status/campagna-status-delete-dialog.html',
                    controller: 'CampagnaStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CampagnaStatus', function(CampagnaStatus) {
                            return CampagnaStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-status', null, { reload: 'campagna-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
